import React from 'react'
import Layout from '../components/Layouts/Layout'
import { Container, Row, Col } from 'react-bootstrap'
import CarouselBanner from '../components/CarouselBanner'
import CarouselTestimonial from '../components/CarouselTestimonial'
import SlickSliderGallery from '../components/SlickSliderGallery'
import WhyAtumCharge from '../components/WhyAtumCharge'
import { Link } from 'react-router-dom';
import { ASSET_URL } from '../config/config';

const Home = () => {
  return (
    <>
      <Layout>
        {/* ***************************************** BANNER SECTION STARTS ******************************************** */}
        <section className='carousel-banner'> <CarouselBanner /> </section>
        {/* ***************************************** ABOUT SECTION STARTS ******************************************** */}
        <Container className='about'>
          <Row className='align-items-center'>
            <Col lg={5}>
              <div className="aboutImg d-flex mx-auto">
                <img src={ASSET_URL+'assets/images/about/about.webp'} className="w-100 rounded-circle" alt="background" />
              </div>
            </Col>

            <Col lg={7}>
              <div className="about-block-wrapper mt-5 mt-sm-5 mt-md-0 mt-lg-0">
                <div className="about-block">
                  <div className="heading heading-1">
                    <h2 className="heading-title">How we make a difference</h2>
                    <p className="heading-desc">ATUM CHARGE is installed 250 solar-powered EV charging stations in
                      India as of now. ATUM CHARGE installing min. capacity of 1.3kW (4panels) to higher as per Annexure-1
                      provided details, for 4kW capacity panels that can charge up to 10-12 vehicles (2/3/4
                      wheelers) per day.</p>
                    <p className="heading-desc">The new age ‘green revolution’ is here, and ATUM Charge is leading the way. Say hello to India’s 1st Solar Powered EV Charging Station that’s giving conventional EV charging stations a serious run for their money! From the house of Visaka, where sustainability is the norm, ATUM Charge derives its power from ATUM Solar Roof – The World’s 1st Integrated Solar Roof, which means that ATUM Charge is using the power of the sun to power-up your EV. How neat is that? Not to mention clean and green.</p>
                    <div className='read-more'>
                      <Link to="/aboutus" className="btn btn-primary">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        {/* ********************************** WHY ATUM CHARGE STARTS **************************************** */}
        <section className='features bg-grey'>
          <div className='heading'>
            <h2 className="heading-title text-center">Why Atum Charge?</h2>
          </div>
          <Container>
            <WhyAtumCharge />
          </Container>
        </section>
        {/* ********************************** GALLERY SECTION STARTS **************************************** */}
        <section className='slick-slider-gallery'>
          <div className='heading'>
            <h2 className="heading-title text-center">Our Gallery</h2>
          </div>

          <Container>
            <SlickSliderGallery />
          </Container>
        </section>
        {/* ********************************** TESTIMONIAL SECTION STARTS **************************************** */}
        <section className='carousel-testimonial'>
          <div className='heading'><h2 className="heading-title text-center">Testimonials</h2></div>
          <Container>
            <CarouselTestimonial />
          </Container>
        </section>
      </Layout>
    </>
  )
}

export default Home